//import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import resume from './modules/resume';

import { Storage } from '../util/storage'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

const state = {
    token: '', // 登录的taken
    seconds: '', // 过期时间
    expectName: '', // 行家名字
    userInfo: { // 行家信息
        id: '',
        phoneNum: '',
        authStatus: '',
        serviceStatus: ''
    },
    personToken: '',//求职者token
    personSeconds: '',//过期时间
    personUserInfo: Storage.get('personUserInfo') || '',
    isEdit: false,
    expectItemNum: 0, // 显示行家服务项目 1表示全部 2表示简历优化  3表示职业规划
    resumeId: 0,
    isSerStatus: false, // 服务状态弹窗
    thisroute:''
};

const mutations = {
    setStatus(state, data) {
        state.isSerStatus = data
    },
    userInfo(state, data) {
        state.userInfo.id = data.id;
        state.userInfo.phoneNum = data.phoneNum;
        state.userInfo.authStatus = data.authStatus;
        state.userInfo.serviceStatus = data.serviceStatus;
    },
    expectName(state, data) {
        state.expectName = data
    },
    expectItemNum(state, data) {
        state.expectItemNum = data
    },
    token(state, data) {
        state.token = data
    },
    seconds(state, data) {
        state.seconds = data
    },
    setEditting(state, data) {
        state.isEdit = !state.isEdit;
    },
    personUserInfo(state, data) {
        state.personUserInfo = data
    },
    personToken(state, data) {
        state.personToken = data
    },
    personSeconds(state, data) {
        state.personSeconds = data
    },
    setroute(state, data) {
        state.thisroute = data
    }
};

const actions = {
    handlerStatus({ commit }, data) {
        commit('setStatus', data)
    },

    userInfo({
        commit
    }, data) {
        commit('userInfo', data)
        sessionStorage.setItem('loginUserBaseInfo', JSON.stringify(data))
    },
    token({
        commit
    }, data) {
        commit('token', data)
        sessionStorage.setItem("token", 'Bearer ' + data)
    },
    expectName({
        commit
    }, data) {
        commit('expectName', data)
        sessionStorage.setItem('expectName', data)
    },
    expectItemNum({
        commit
    }, data) {
        commit('expectItemNum', data)
        sessionStorage.setItem('expectItemNum', data)
    },
    seconds({
        commit
    }, data) {
        commit('seconds', data)
        sessionStorage.setItem("seconds", JSON.stringify(data))
    },
    setEdit({
        commit
    }, data) {
        commit('setEditting', data)
    },
    personUserInfo({
        commit
    }, data) {
        Storage.set('personUserInfo', data)
        commit('personUserInfo', data)
    },
    personToken({
        commit
    }, data) {
        Storage.set("personToken", 'Bearer ' + data)
        commit('personToken', data)

    },
    personSeconds({
        commit
    }, data) {
        Storage.set("personSeconds", data)
        commit('personSeconds', data)
    },
    quit({ commit }) {
        Storage.remove('personUserInfo')
        Storage.remove('personToken')
        Storage.remove('personSeconds')
        commit('personUserInfo', '')
        commit('personToken', '')
        commit('personSeconds', '')

    },
    setroute({
        commit
    }, data) {
        commit('setroute', data)
    }
};
const getters = {
    userInfo(state) {
        return state.userInfo
    },
    token(state) {
        return state.token
    },
    expectName(state) {
        return state.expectName
    },
    expectItemNum(state) {
        return state.expectItemNum
    },
    seconds(state) {
        return state.seconds
    },
    isSerStatus(state) {
        return state.isSerStatus
    },
    personUserInfo(state) {
        return state.personUserInfo
    }
};



export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        resume,
    },
    strict: debug,
    //plugins:debug?[createLogger()]:[]
})



// WEBPACK FOOTER //
// ./src/store/index.js